module.exports = __webpack_public_path__ + "img/Bokio-1024x380.5f1c4543.png";